import CalorstatWebservice from '../services/calorstat-webservice';

class CatalogSearchForm {

    constructor($el) {
        this.$el = $el;
        this.searchFields = [];
        this.searchMethods = [];
        this.formData = {};
        this.formDataFieldsNames = [];

        this._findDOMElements();
        this._setupSearchForm();
        this._bindEvents();
        this._fillWithData(0);
    }

    _bindEvents() {
        this.searchFields.forEach(($el, index) => {
            let nextFieldIndex = index + 1;

            // // Skip `first_registration_month` field and use `family_code` field index
            // if(!cal.isYearMakeModelCountries && $el[0].name === 'first_registration_year') {
            //     nextFieldIndex = index + 2;
            // }

            $el.on('change', this._fillWithData.bind(this, index, nextFieldIndex));

            if($el[0].tagName === 'SELECT') {
                let enableSearch = Infinity;
                const searchEnabledFieldsIDs = [
                    'catalog-search-form__brand-selectbox',
                    'catalog-search-form__model-selectbox',
                    'catalog-search-form__engine-selectbox',
                    'catalog-search-form__year-of-first-registration-selectbox'
                ];

                // Enable value search on specific fields
                if(searchEnabledFieldsIDs.indexOf($el.attr('id')) !== -1) {
                    enableSearch = 2;
                }

                $el.select2({
                    lang: cal.lang,
                    placeholder: $el.find('option:first-child').text(),
                    minimumResultsForSearch: enableSearch,
                    width: '100%'
                });
                $el.on('select2:select', this._clearFieldErrorIndicator.bind(this));
            }
        });

        this.$catalogSelectboxes.each((index, el) => {
            const $el = $(el);
            
            $el.select2({
                lang: cal.lang,
                placeholder: $el.find('option:first-child').text(),
                minimumResultsForSearch: Infinity,
                width: '100%'
            });
            $el.on('select2:select', this._clearFieldErrorIndicator.bind(this));
        });

        // Reference & engine code error indicator removal
        this.$referenceField.on('keydown', this._clearFieldErrorIndicator.bind(this));
        this.$engineCodeField.on('keydown', this._clearFieldErrorIndicator.bind(this));

        // Search type change
        this.$searchTypes.on('change', this._toggleSearchType.bind(this));
        this.$searchTypes.on('click', this._openForm.bind(this));

        // Open, close & submit search form
        this.$newSearchButton.on('click', this._openForm.bind(this));
        this.$closeFormButton.on('click', this._closeForm.bind(this));
        this.$submitButtons.on('click', this._validateForm.bind(this));
    }

    _findDOMElements() {
        // Catalog selection field
        this.$catalogSelectboxes = this.$el.find('.catalog-search-form__catalog-selectbox');

        // Search fields
        // Vehicle search fields
        this.$brandSelectbox = this.$el.find('#catalog-search-form__brand-selectbox');
        this.$modelSelectbox = this.$el.find('#catalog-search-form__model-selectbox');
        this.$engineSelectbox = this.$el.find('#catalog-search-form__engine-selectbox');
        this.$dateFirstRegistrationSelectbox = this.$el.find('#catalog-search-form__date-of-first-registration-selectbox');
        this.$yearFirstRegistrationSelectbox = this.$el.find('#catalog-search-form__year-of-first-registration-selectbox');
        this.$familySelectbox = this.$el.find('#catalog-search-form__family-selectbox');
        // Reference search field
        this.$referenceField = this.$el.find('.catalog-search-form--reference-search .catalog-search-form__text-field');
        // Engine code search field
        this.$engineCodeField = this.$el.find('.catalog-search-form--engine-code-search .catalog-search-form__text-field');

        // Search type inputs & fieldsets by search type
        this.$searchTypes = this.$el.find('input[name=search-type]');
        this.$searchTypesRadioInputsEls = this.$el.find('.catalog-search-form__radio-input');
        this.$vehiculeSearchFields = this.$el.find('.catalog-search-form--vehicule-search');
        this.$referenceSearchFields = this.$el.find('.catalog-search-form--reference-search');
        this.$engineCodeSearchFields = this.$el.find('.catalog-search-form--engine-code-search');

        // Open, close & submit buttons
        this.$newSearchButton = this.$el.find('.new-search-button');
        this.$closeFormButton = this.$el.find('.catalog-search-form__close-button');
        this.$submitButtons = this.$el.find('.catalog-search-form__submit-button');
    }

    _setupSearchForm() {
        this.$catalogSelectboxes.each(function(index, selectbox) {
            var $selectbox = $(selectbox);
            
            $selectbox.select2({
                lang: cal.lang,
                placeholder: $selectbox.find('option:first-child').text(),
                minimumResultsForSearch: Infinity,
                width: '100%'
            });
        });

        // Make/Model/Year countries handling
        if(!cal.isYearMakeModelCountries) {
            this.searchFields = [
                this.$brandSelectbox,
                this.$modelSelectbox,
                this.$engineSelectbox,
                this.$yearFirstRegistrationSelectbox,
                this.$familySelectbox
            ];
            this.searchMethods = [
                'getManufacturers',
                'getModelsByManufacturer',
                'getEnginesByManufacturerAndModel',
                // 'getPeriodsByManufacturerAndModelAndEngine',
                'getYearsByManufacturerAndModelAndEngine',
                'getFamiliesByManufacturerAndModelAndEngineAndYear',
                'getFamiliesByManufacturerAndModelAndEngineAndYear'
            ];
            this.formDataFieldsNames = [
                this.$brandSelectbox.attr('name'),
                this.$modelSelectbox.attr('name'),
                this.$engineSelectbox.attr('name'),
                // this.$dateFirstRegistrationSelectbox.attr('name'),
                this.$yearFirstRegistrationSelectbox.attr('name'),
                this.$familySelectbox.attr('name')
            ];
        }
        // Year/Make/Model countries handling
        else {
            this.searchFields = [
                this.$dateFirstRegistrationSelectbox,
                this.$brandSelectbox,
                this.$modelSelectbox,
                // this.$engineSelectbox,
                this.$familySelectbox
            ];
            this.searchMethods = [
                'getYears',
                'getManufacturersByYear',
                'getModelsByYearAndManufacturer',
                'getFamiliesByYearAndManufacturerAndModel'
            ];
            this.formDataFieldsNames = [
                this.$dateFirstRegistrationSelectbox.attr('name'),
                this.$brandSelectbox.attr('name'),
                this.$modelSelectbox.attr('name'),
                // this.$engineSelectbox.attr('name'),
                this.$familySelectbox.attr('name')
            ];
        }
    }

    _fillWithData(triggeringFieldIndex, nextFieldIndex = 0) {
        if(this.searchFields[nextFieldIndex]) {
            const methodName = this.searchMethods[nextFieldIndex];
            const nextField = this.searchFields[nextFieldIndex];

            this.formData['market'] = this.$catalogSelectboxes.val();

            if(nextFieldIndex > 0) {
                // let triggeringFieldIndex = nextFieldIndex - 1;

                // Get correct triggering field index when `first_registration_year` triggers change event
                // if(!cal.isYearMakeModelCountries && nextFieldIndex === (this.searchFields.length - 1)) {
                //     triggeringFieldIndex = nextFieldIndex - 2;
                // }

                let triggeringField = this.searchFields[triggeringFieldIndex];
                this.formData[this.formDataFieldsNames[triggeringFieldIndex]] = triggeringField.val();
            }

            for(let i = 0; i < this.searchFields.length; i ++) {
                if(i >= nextFieldIndex) {
                    // this.searchFields[i].val(null).trigger('change');
                    this.searchFields[i].val(null);

                    // Prevent `first_registration_month` from being emptied during field reset
                    // if(cal.isYearMakeModelCountries || (!cal.isYearMakeModelCountries && i !== (this.searchFields.length - 2))) {
                        this.searchFields[i].find('option:not(:first-child)').remove().trigger('change.select2');
                    // }

                    this.searchFields[i].trigger('change.select2');
                }
            }

            if(methodName && CalorstatWebservice[methodName]) {
                CalorstatWebservice[methodName]({
                    data: this.formData,
                    onSuccess: (json) => {
                        if(json.length) {
                            var options = [];

                            json.forEach((data) => {
                                let optionLabel = '';
                                let optionValue = '';

                                if((methodName === 'getFamiliesByManufacturerAndModelAndEngineAndYear' || methodName === 'getFamiliesByYearAndManufacturerAndModel') && data['family_Code']) {
                                    optionValue = this._normalizeData(data['family_Code']);

                                    if(data['family_' + cal.lang.toUpperCase()]) {
                                        optionLabel = data['family_' + cal.lang.toUpperCase()];
                                    }
                                    else if(data['family_' + cal.defaultLang.toUpperCase()]) {
                                        optionLabel = data['family_' + cal.defaultLang.toUpperCase()];
                                    }
                                }
                                else {
                                    optionLabel = data;
                                    optionValue = this._normalizeData(data);
                                }

                                if(optionLabel && optionValue) {
                                    options.push(new Option(optionLabel, optionValue, false, false));
                                }
                            });

                            nextField.append(options).removeAttr('disabled');

                            // // Enable `first_registration_month` when the webservice return results
                            // if(!cal.isYearMakeModelCountries && triggeringFieldIndex === 3) {
                            //     this.searchFields[nextFieldIndex - 1].removeAttr('disabled');
                            // }
                        }
                    },
                    onError: function(jqxhr, textStatus, error) {
                        console.log('error', jqxhr, textStatus, error);
                    },
                    onComplete: function() {}
                });
            }
        }
    }

    _validateForm(e) {
        // Clear error indicators
        this.$el.find('.catalog-search-form--error').removeClass('catalog-search-form--error');

        const selectedSearchType = this._getSearchType();
        let lastMandatoryFieldsIndex = -1;
        let searchIndex = 0;
        let hasError = false;

        // Validate until the field before penultimate field
        if(!cal.isYearMakeModelCountries) {
            lastMandatoryFieldsIndex = this.searchFields.length - 2;
        }
        // Validate until the penultimate field
        else {
            lastMandatoryFieldsIndex = this.searchFields.length - 1;
        }

        if(selectedSearchType === 'vehicule-search') {
            searchIndex = 0;

            this.searchFields.forEach(($el, index) => {
                const fieldValue = $el.val();

                if(index < lastMandatoryFieldsIndex && (fieldValue === '' || fieldValue === null || fieldValue == -1)) {
                    $el.data('select2').$selection.addClass('catalog-search-form--error');
                    hasError = true;
                }
            });

            const $currentCatalogSelectbox = this.$catalogSelectboxes.eq(0);
            const currentCatalogSelectboxValue = $currentCatalogSelectbox.val();
            if(currentCatalogSelectboxValue === '' || currentCatalogSelectboxValue === null || currentCatalogSelectboxValue == -1) {
                $currentCatalogSelectbox.data('select2').$selection.addClass('catalog-search-form--error');
                hasError = true;
            }
        }
        else if(selectedSearchType === 'reference-search') {
            searchIndex = 1;

            if(this.$referenceField.val().length < 3) {
                this.$referenceField.addClass('catalog-search-form--error');
                hasError = true;
            }

            
        }
        else if(selectedSearchType === 'engine-code-search') {
            searchIndex = 2;

            if(this.$engineCodeField.val().length < 3) {
                this.$catalogSelectboxes.addClass('catalog-search-form--error');
                this.$engineCodeField.addClass('catalog-search-form--error');
                hasError = true;
            }
        }

        /// Validate catalog selection selectbox
        const $currentCatalogSelectbox = this.$catalogSelectboxes.eq(searchIndex);
        const currentCatalogSelectboxValue = $currentCatalogSelectbox.val();
        if(currentCatalogSelectboxValue === '' || currentCatalogSelectboxValue === null || currentCatalogSelectboxValue == -1) {
            $currentCatalogSelectbox.data('select2').$selection.addClass('catalog-search-form--error');
            hasError = true;
        }

        if(hasError) {
            e.preventDefault();
        }
    }

    _clearFieldErrorIndicator(e) {
        const $currentTarget = $(e.currentTarget);

        if(e.type === 'select2:select') {
            const data = e.params.data;

            if(data.id !== '' && data.id !== null && data.id != -1) {
                $currentTarget.data('select2').$selection.removeClass('catalog-search-form--error');
            }
        }
        else if(e.type === 'keydown') {
            if($currentTarget.hasClass('catalog-search-form--error')) {
                $currentTarget.removeClass('catalog-search-form--error');
            }
        }
    }

    _openForm(e) {
        // e.preventDefault();

        if(this.$el.hasClass('catalog-search-form--hidden')) {
            this.$el.removeClass('catalog-search-form--hidden');
        }
    }

    _closeForm(e) {
        // e.preventDefault();

        if(!this.$el.hasClass('catalog-search-form--hidden')) {
            this.$el.addClass('catalog-search-form--hidden');
        }
    }

    _getSearchType() {
        return this.$searchTypes.filter(':checked').val();
    }

    _toggleSearchType(e) {
        const selectedSearchType = this._getSearchType();
        const $target = $(e.currentTarget);
        const $radioInput = $target.parents('.catalog-search-form__radio-input');

        this.$searchTypesRadioInputsEls.removeClass('catalog-search-form__radio-input--checked');

        if($radioInput.length) {
            if($target.is(':checked')) {
                $radioInput.addClass('catalog-search-form__radio-input--checked');
            }
            else {
                $radioInput.removeClass('catalog-search-form__radio-input--checked');
            }
        }

        if(selectedSearchType === 'vehicule-search') {
            this.$engineCodeSearchFields.addClass('catalog-search-form__fieldset--hidden');
            this.$referenceSearchFields.addClass('catalog-search-form__fieldset--hidden');
            this.$vehiculeSearchFields.removeClass('catalog-search-form__fieldset--hidden');
        }
        else if(selectedSearchType === 'reference-search') {
            this.$vehiculeSearchFields.addClass('catalog-search-form__fieldset--hidden');
            this.$engineCodeSearchFields.addClass('catalog-search-form__fieldset--hidden');
            this.$referenceSearchFields.removeClass('catalog-search-form__fieldset--hidden');
        }
        else if(selectedSearchType === 'engine-code-search') {
            this.$vehiculeSearchFields.addClass('catalog-search-form__fieldset--hidden');
            this.$referenceSearchFields.addClass('catalog-search-form__fieldset--hidden');
            this.$engineCodeSearchFields.removeClass('catalog-search-form__fieldset--hidden');
        }
    }

    _normalizeData(data) {
        return data.toLowerCase();
    }
}

export default CatalogSearchForm;
